'use strict';

const _ = require('lodash');
const Backbone = require('backbone');
const byId = {};

const widgets = module.exports = {
    add: function (id, widget) {
        if (byId[id]) {
            throw new Error(`Duplicate widget id : ${id}`);
        }

        byId[id] = widget;
    },
    get: function (id) {
        if (!byId[id]) {
            throw new Error(`Widget not found : ${id}`);
        }

        return byId[id];
    },
    build: function (curation, definitions) {
        if (_.isArray(definitions)) {
            return new Backbone.Collection(_.map(definitions, _.partial(build, curation)));
        }

        return build(curation, definitions);
    }
};

function build(curation, definition) {
    const Widget = widgets.get(definition.widgetId);
    return new Widget(curation, definition);
}
